/**
 * WHICH HEADER TAB IS UNDERLINED (punch list F109, Jeremy 30 Oct 2026,
 * option A). A tab used to be underlined only on its own page, so a task,
 * deliverable or project page underlined none and people lost track of where
 * they were. Now those pages keep the tab you came from underlined: open a
 * task from My work and My work stays underlined.
 *
 * Remembered per BROWSER TAB (sessionStorage), so two windows on two screens
 * each keep their own. A link opened fresh -- from an email or Teams --
 * remembers nothing and underlines nothing, rather than guessing.
 */
import type { Route } from "./router";

export type NavTab = "home" | "projects" | "workload" | "attention" | "overview" | "admin" | "punchlist";

const TABS: ReadonlySet<string> = new Set<NavTab>([
  "home",
  "projects",
  "workload",
  "attention",
  "overview",
  "admin",
  "punchlist",
]);

/** The pages that sit UNDER a tab rather than being one. */
const DETAIL: ReadonlySet<Route["kind"]> = new Set<Route["kind"]>(["project", "deliverable", "task"]);

/** The tab to underline: the route's own, or on a detail page the one remembered. */
export function navTabFor(route: Route, remembered: NavTab | null): NavTab | null {
  if (TABS.has(route.kind)) return route.kind as NavTab;
  return DETAIL.has(route.kind) ? remembered : null;
}

const KEY = "canopy:navTab";

/** Wrapped: storage can be unavailable, and a tab underline is never worth an error. */
export function readRememberedTab(): NavTab | null {
  try {
    const v = window.sessionStorage.getItem(KEY);
    return v !== null && TABS.has(v) ? (v as NavTab) : null;
  } catch {
    return null;
  }
}

export function rememberTab(tab: NavTab): void {
  try {
    window.sessionStorage.setItem(KEY, tab);
  } catch {
    // Nothing to do: the underline falls back to the route's own tab.
  }
}
